import Box from '@mui/material/Box';
import { FC } from 'react';

import { ProDirectoryPreviewCard, ProDirectoryPreviewData } from './preview-card';
import { ProDirectoryPreviewCardPlaceholder } from './preview-card-placeholder';

type Props = {
  data: ProDirectoryPreviewData;
};

const BEFORE_PLACEHOLDER_IDS = ['before-1'];
const AFTER_PLACEHOLDER_IDS = ['after-1', 'after-2', 'after-3', 'after-4', 'after-5', 'after-6'];

export const SearchCardPreviewGrid: FC<Props> = ({ data }) => {
  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 2.5,
        }}
      >
        {BEFORE_PLACEHOLDER_IDS.map(id => (
          <ProDirectoryPreviewCardPlaceholder key={id} />
        ))}
        <ProDirectoryPreviewCard data={data} />
        {AFTER_PLACEHOLDER_IDS.map(id => (
          <ProDirectoryPreviewCardPlaceholder key={id} />
        ))}
      </Box>
    </Box>
  );
};
